export const init = {
  density: "70",
  size: "40x50",
  color: "белый",
  face_colors: 1,
  rear_colors: 1,
  same_print: false,
  quantity: 200,
  quantity_manual: 0,
  min_quantity: 100,
  markups: [],
};
